module.exports = __webpack_public_path__ + "media/logos/Marriott 1-0faed99c.svg";